import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import SectionContainer from '../../components/UI/SectionContainer';
import { openAlert } from '../../utils/common';
import { userIdxToCaseId } from '../../utils/calibrationAdmin';

/**
 * 회원 상세 팝업 — 보정 운영은 /calibration 으로 이동.
 */
const UserAiModelPage = () => {
  const { userIdx } = useParams();
  const navigate = useNavigate();
  const caseId = userIdxToCaseId(userIdx);

  useEffect(() => {
    if (!caseId) {
      openAlert({ title: '알림', description: '올바른 접근이 아닙니다.' });
    }
  }, [caseId]);

  if (!caseId) {
    return (
      <SectionContainer title="보정 처리">
        <p>유효하지 않은 회원입니다.</p>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer title="보정 처리">
      <p style={{ color: '#666', marginBottom: 16 }}>
        보정 raw 다운로드·AI 모델 업로드는 <strong>보정 관리</strong> 메뉴에서 처리합니다.
      </p>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => navigate(`/calibration/cases/${encodeURIComponent(caseId)}`)}
      >
        보정 처리 화면으로 이동 ({caseId})
      </button>
      <p style={{ marginTop: 12 }}>
        <Link to="/calibration/queue">보정 대기열 보기</Link>
      </p>
    </SectionContainer>
  );
};

export default UserAiModelPage;
